import { useEffect, useRef, useState } from "react";
import "./PaymentMethod.css";
import { X } from "lucide-react";

const PaymentMethod = ({
  onClose,
  onSelect,
  onlyFPX,
  orderNum,
  orderId,
  totalAmount,
}) => {
  const [selectedMethod, setSelectedMethod] = useState(null);
  const [error, setError] = useState("");
  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [onClose]);

  // If onlyFPX, set it to FPX without rendering the popup
  useEffect(() => {
    if (onlyFPX && onSelect) {
      onSelect("FPX");
    }
    // eslint-disable-next-line
  }, [onlyFPX, onSelect]);

  if (onlyFPX) return null;

  const handleSelectMethod = (value) => {
    setSelectedMethod(selectedMethod === value ? null : value);
    setError(""); // clear error on change
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!selectedMethod) {
      setError("Please select a payment method.");
      return;
    }

    if (onSelect) {
      onSelect(selectedMethod);
    }
  };

  return (
    <div className="paymentmethod_v2">
      <div className="paymentmethod-content_v2" ref={modalRef}>
        <div className="paymentmethod-title-container_v2">
          <div className="paymentmethod-title_v2">
            <strong>Select Payment Method</strong>
          </div>
          <button className="pmclose-button_v2" onClick={onClose}>
            <X />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="paymentmethod-main_v2">
            <div className="paymentmethod-label_v2">
              You are about to pay for <span>{orderId}</span>.
            </div>

            <div className="paymentmethod-total_v2">
              <div className="paymenthod-total-item_v2 first-item">
                <div>Order Selected :</div>
                <div>{orderNum}</div>
              </div>

              <div className="paymenthod-total-item_v2">
                <div>Total Amount:</div>
                <div className="paymentmethod-total-value_v2">
                  <div className="paymentmethod-RM_v2">RM</div>
                  {totalAmount}
                </div>
              </div>
            </div>

            <div className="paymentby_v2">Payment by :</div>

            <div className="pmoptions_v2">
              <label className="pmoption1_v2">
                <input
                  type="checkbox"
                  checked={selectedMethod === "FPX"}
                  onChange={() => handleSelectMethod("FPX")}
                />
                FPX
              </label>

              {!onlyFPX && (
                <label className="pmoption1_v2">
                  <input
                    type="checkbox"
                    checked={selectedMethod === "Online Banking"}
                    onChange={() => handleSelectMethod("Online Banking")}
                  />
                  IBG
                </label>
              )}

              {error && (
                <div
                  style={{
                    color: "red",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  {error}
                </div>
              )}
            </div>
          </div>

          <div className="paymentmethod-sub_v2">
            <button className="pm-cancel_v2" onClick={onClose}>
              Cancel
            </button>

            <button className="pm-ok_v2" type="submit">
              Confirm
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PaymentMethod;
